import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import RecaptchaState from '../common/states/RecaptchaState';
import Recaptcha from '../common/components/Recaptcha';
export const isRecaptchaConfigured = () => !!app.forum.attribute('fof-recaptcha.configured');
export const canPostWithoutCaptcha = () => !!app.forum.attribute('postWithoutCaptcha');
export const shouldUseCaptcha = () => isRecaptchaConfigured() && !canPostWithoutCaptcha();
export default function extendComposer(modulePath, action) {
  extend(modulePath, 'oninit', function () {
    if (!shouldUseCaptcha()) return;
    const self = this;
    self.recaptcha = new RecaptchaState(app.forum.data.attributes, action, () => {
      // Callback is unused here; the async acquireToken() flow handles invisible/v3, and v2 checkbox
      // reads the token synchronously via getResponse() at submit time.
    });
    self.recaptchaToken = null;
  });
  extend(modulePath, 'data', function (data) {
    if (!shouldUseCaptcha()) return;
    const self = this;

    // For v2 checkbox we read the token straight from the widget. For invisible/v3 we use the token
    // previously captured in the onsubmit override below.
    data['g-recaptcha-response'] = self.recaptcha.requiresAsyncToken() ? self.recaptchaToken ?? '' : self.recaptcha.getResponse();
    data['g-recaptcha-action'] = self.recaptcha.action;
  });
  extend(modulePath, 'headerItems', function (items) {
    if (!shouldUseCaptcha()) return;
    const self = this;

    // The Recaptcha component is rendered for every type, including v3 (where it's an invisible
    // marker div). Mounting it in all modes is how the grecaptcha script gets loaded.
    items.add('recaptcha', m(Recaptcha, {
      state: self.recaptcha
    }), -5);
  });

  // There's no onerror handler on composer classes, but we can react to loaded which is called after errors.
  extend(modulePath, 'loaded', function () {
    if (!shouldUseCaptcha()) return;
    const self = this;
    self.recaptchaToken = null;
    self.recaptcha.reset();
  });
  override(modulePath, 'onsubmit', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const self = this;
    const proceed = () => original(...args);
    if (!shouldUseCaptcha()) {
      return proceed();
    }

    // v2 checkbox: block the submit client-side if the user hasn't completed the captcha, rather
    // than letting the server reject the post with a generic validation error.
    if (!self.recaptcha.requiresAsyncToken() && !self.recaptcha.getResponse()) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('fof-recaptcha.lib.not_completed'));
      return;
    }
    if (!self.recaptcha.requiresAsyncToken() || self.recaptchaToken !== null) {
      return proceed();
    }
    self.loading = true;
    self.recaptcha.acquireToken().then(token => {
      self.recaptchaToken = token;
      proceed();
    }).catch(() => {
      self.loading = false;
      m.redraw();
    });
  });
}